export const Table = {
    Patient: 1,
    History: 2,
    Diagnosis: 3,
    Research: 4,
    PatientExpenditure: 5,
    Payment: 6,
    Invoice: 7,
    Pharmacy: 8,
    ProductTransfer: 9,
    Document: 10
};

export const WorkflowAction = {
    Add: 1,
    Modify: 2,
    Delete: 3
};

export const WorkflowRequestStatusEnum = {
    Requested: 1,
    Approved: 2,
    Rejected: 3,
    Error: 4,
    Canceled: 5
};

export const PermissionEnum = {
    AddPatient: 1,
    EditPatient: 2,
    AddHistory: 3,
    EditHistory: 4,
    AddDiagnosis: 5,
    EditDiagnosis: 6,
    SidebarPayment: 7,
    SidebarSponsor: 8,
    SidebarInpatientEnter: 9,
    SidebarInpatientLeave: 10,
    SidebarOutpatientCard: 11,
    SidebarDiagnosisOpen: 12,
    SidebarDiagnosisClose: 13,
    SidebarResearchesOnly: 14,
    AddResearch: 17,
    EditResearch: 18,
    ResearchPayment: 19,
    ResearchPaymentPayCash: 20,
    ResearchPaymentPayTerminal: 21,
    ResearchPaymentPayTrasnfer: 22,
    ResearchPaymentPayBalance: 23,
    ResearchPaymentReturnCash: 24,
    ResearchPaymentReturnTerminal: 25,
    ResearchPaymentReturnTransfer: 26,
    ResearchPaymentReturnBalance: 27,
    ResearchPaymentPrice: 28,
    ResearchPaymentDocForCheck_CHGD: 29,
    ResearchPaymentDatetime: 30,
    ResearchStatusActionReject: 31,
    ResearchStatusActionEnqueue: 32,
    ResearchStatusActionComplete: 33,
    ResearchStatusActionPostpone: 34,
    ResearchPaymentDelete: 35,
    ResearchPaymentRecalculateByDate: 36,
    ResearchPaymentRecalculateByCreator: 37,
    ResearchPaymentBalanceCash: 38,
    ResearchPaymentBalanceTerminal: 39,
    ResearchPaymentBalanceTransfer: 40,
    ResearchPaymentBalanceBalance: 41,
    PaymentUpToDay: 42,
    ResearchToday: 43,
    HistoryCutomAction: 44,
    HistoryCutomActionA4Page1: 45,
    HistoryCutomActionA4Page2: 46,
    CashDeleteBeforeToday: 47,
    ResearchAfterBlock: 48,
    HistoryCutomActionRememberDiagnosis: 49,
    PrimaCardAdd: 50,
    PrimaCardContinue: 51,
    LoadPatientInfo: 52,
    SidebarMyPatient: 53,
    SidebarCreatedByMe: 54,
    UserInfoPaymentTotals: 55,
    PrimaCardDelete: 56,
    PaymentDeleteCreatedByOther: 57,
    MtrediCardOffer: 58,
    CreateElFormReport: 59,
    OpenElFormReport: 60,
    SidebarMedicamentByHistory: 61,
    SidebarMedicamentByDiagnosis: 62,
    ResearchPaymentDiagnosisCash: 63,
    ResearchPaymentDiagnosisTerminal: 64,
    ResearchPaymentDiagnosisTransfer: 65,
    ResearchPaymentDiagnosisBalance: 66,
    AddMkurnal: 67,
    SidebarResearchInPatient: 68,
    DeleteDiagnosis: 69,
    ResearchPaymentResearchDebtTransfer: 70,
    ResearchPaymentDiagnosisDebtTransfer: 71,
    ResearchContextFavouriteElForms: 72,
    MenuModule: 73,
    MenuModulePatient: 74,
    MenuModuleTimetable: 75,
    MenuModulePharmacy: 76,
    ResearchPaymentBalanceOutCash: 77,
    ResearchPaymentBalanceOutTerminal: 78,
    ResearchPaymentBalanceOutTransfer: 79,
    ResearchPaymentBalanceOutBalance: 80,
    QueueNextPatient: 81,
    QueueSetPatientQueueNumber: 82,
    MenuModuleDoctorForm: 83,
    PharmacyInvoiceAdd: 84,
    PharmacyInvoiceEdit: 85,
    PharmacyInvoiceDelete: 86,
    PharmacyDelete: 87,
    ProductTransferDelete: 88,
    ChooseNosologyByDoctor: 89,
    ChooseDoctorByNosology: 90,
    ByBase: 91,
    QueueButtons: 92,
    OrganizationAdd: 93,
    OrganizationEdit: 94,
    DepartmentAdd: 95,
    DepartmentEdit: 96,
    MenuModulePharmacyGood: 97,
    LoadBeneficiaryInfo: 98,
    MenuModuleBrunva: 99,
    FileAttachmentUpload: 100,
    FileAttachmentNewFolder: 101,
    MedicamentAfterBlock: 102,
    MedicamentAdd: 103,
    MedicamentEdit: 104,
    GoodAdd: 105,
    GoodEdit: 106,
    SidebarDiagnosisDepartmentByHistory: 107,
    SidebarDiagnosisDepartmentByDiagnosis: 108,
    DiagnosisDepartmentAdd: 109,
    DiagnosisDepartmentEdit: 110,
    DiagnosisDepartmentDelete: 111,
    SidebarHistorySalary: 112,
    HistorySalaryAdd: 113,
    HistorySalaryEdit: 114,
    HistorySalaryDelete: 115,
    SidebarSurgery: 116,
    SurgeryAdd: 117,
    SurgeryEdit: 118,
    SurgeryDelete: 119,
    MohEhrSend: 120,
    MenuLog: 121,
    MenuLogMohEhr: 122,
    EditBlockedDiagnosis: 123,
    MohEhrLogSend: 124,
    SidebarPrescriptionByHistory: 125,
    SidebarPrescriptionByDiagnosis: 126,
    MohEhrApprovalStatusChange: 127,
    PrescriptionAdd: 128,
    PrescriptionEdit: 129,
    PrescriptionBlock: 130,
    MenuModuleConsumption: 131,
    SidebarHistoryIcd: 132,
    DocumentAdd: 133,
    DocumentEdit: 134,
    DocumentDelete: 135,
    PatientPermissionForPersonalInfo: 136,
    HistoryIcdDelete: 137,
    MenuModulePrices: 138,
    ResearchGridActionMove: 139,
    MkurnalGridActionMove: 140,
    MenuModuleReport: 141,
    ElFormPrint: 142,
    PrimaCardAnyDate: 143,
    PreventTerraResultPrint: 144,
    PricesAdd: 145,
    PricesEdit: 146,
    PricesDelete: 147,
    ProductSellPay: 148,
    ProductSellDelete: 149,
    HistoryFeedingAdd: 150,
    HistoryFeedingEdit: 151,
    HistoryFeedingDelete: 152,
    SidebarHistoryFeeding: 153,
    MedicamentLink: 154,
    ResearchPaybackDiagnosisCash: 155,
    ResearchPaybackDiagnosisTerminal: 156,
    ResearchPaybackDiagnosisTransfer: 157,
    ResearchPaybackDiagnosisBalance: 158,
    ResearchLinkToLaboratoryAnswer: 159,
    BalanceDeleteBeforeToday: 160,
    DiagnosisDepartmentEditChamber: 161,
    BrunvaMonthAmountRecalculate: 162,
    LaboratoryResearch: 163,
    ChangeResearchDateWithToday: 164,
    LaboratoryRequest: 167,
    LaboratoryRequestConfirm: 168,
    LaboratoryNormative: 169,
    LaboratoryResultDelete: 170,
    SetAmbulatoryStatusTime: 172,
    LaboratoryRequestStatusFilter: 173,
    LaboratoryRequestDeviceConfig: 174,
    ResearchResultDateTime: 175,
    LaboratoryresultEditAfterConfirm: 176,
    MenuModuleBeneficiary: 177,
    DeleteEhrPrescription: 178,
    MenuModulePricesUpload: 179,
    DeleteOthersMkurnal: 180,
    MenuModuleRequestedPublicService: 181,
    RequestedPublicServiceApprove: 182,
    RequestedPublicServiceRegister: 183,
    MenuModulePerson: 184,
    ResearchCompleteAfterElFormConfirm: 185,
    StandardMedicamentAdd: 186,
    StandardMedicamentEdit: 187,
    StandardMedicamentDelete: 188,
    ResearchElForm: 189,
    ResearchBeginComplete: 190,
    MohEhrResearchApprovalStatusChange: 191,
    BlockedHistoryEdit: 192,
    BlockedWithSalaryHistoryEdit: 193,
    PaymentRool761: 194,
    QueueSetToPatient: 195,
    MenuModuleFavoriteNosology: 196,
    ResearchGridWithoutRecommended: 197,
    ResearchGridArchive: 198,
    PaidSalaryForOthers: 199,
    MenuModuleSms: 200,
    CopyResearchesWithInsurance: 201,
    LoadInsuranceInfo: 202,
    TimetableAdd: 203,
    MenuModuleShift: 204,
    ShiftAdd: 205,
    ShiftDelete: 206,
    ShiftAddInPast: 207,
    ShiftDeleteInPast: 208,
    MarkedPatientsOnly: 209,
    EhrSendOnlySelfAsDoctor: 210,
    SidebarDoctorModule: 211,
    ResearchSynonymManage: 212,
    SidebarDepartmentSummaryOfReseach: 213,
    ResearchEditAddSender: 214,
    MenuModuleNurse: 215,
    MenuModuleDepartmentWardPatient: 216,
    PersonKadr: 217,
    PersonKadrManage: 218,
    PersonPosition: 219,
    PersonPositionManage: 220,
    PersonEducation: 221,
    PersonEducationManage: 222,
    PersonSalary: 223,
    PersonSalaryManage: 224,
    PersonMissWorkDay: 225,
    PersonMissWorkDayManage: 226,
    MenuModuleDepartmentAccess: 227,
    AmbulatoryHistoryToCard: 228,
    AmbulatoryCardToHistory: 229,
    MenuModuleUser: 230,
    MenuModuleHistoryExpire: 231,
    PersonAdd: 232,
    PersonEdit: 233,
    PersonDelete: 234,
    MenuModuleSpeciality: 235,
    PersonSpeciality: 236,
    PersonSpecialityManage: 237,
    PersonVacation: 238,
    PersonVacationManage: 239,
    MenuModuleMohProductMap: 240,
    AllElFormSendEmail: 241,
    MedicamentDelete: 242,
    HideResearchCost: 243,
    InsuranceReliefUpload: 244,
    MenuModuleMessageTemplate: 245,
    MenuModuleMyResearchVisits: 246,
    MenuLogMohCasePdf: 247,
    DynamicElFormMoveToDiagnosis: 248,
    SidebarPermanentElFormModule: 249,
    SidebarOptionalElFormModule: 250,
    MenuModuleOrganizationPaymentInAdvance: 251,
    Calculation: 252,
    MohEStock: 253,
    HistoryDisable: 254,
    Research_SetSender: 255,
    HideResearchWithDebt: 256,
    MenuModuleCashier: 257,
    Research_SetBacteriologicalPreliminaryDiagnosis: 258,
    PrescriptionCreate: 259,
    WebBooking_TodaysAppointmentsWithPatientPId: 260,
    MenuModuleMissingPrescriptionUse: 261,
    ElFormPdfSign_CreateNewDocument: 262,
    PatientSearch: 263,
    PatientHistoryOpen: 264,
    CopySymptomatically: 265,
    Prescription_SetAsMyPrescription: 266,
    Prescription_UsedByMe: 267,
    MenuModulePaidSalary: 268,
    HistoryElForm_Delete: 269,
    HistoryCursus: 270,
    MenuModuleDrugTreatmentTemplate: 271,
    MenuModuleNosologyGroup: 272,
};
